export enum TipoDifferenzaEnum {
  AGGIUNTO = <any>"AGGIUNTO",
  ELIMINATO = <any>"ELIMINATO",
  SOSTITUITO = <any>"SOSTITUITO",
  MODIFICATO = <any>"MODIFICATO",
}
